import { beContentSourceGetSource } from 'Api/beContentSource'

import { beContentProviderGetListOfContents } from 'Api/beContentProvider'

export async function getSourceById(idSource) {
  const resp = await beContentSourceGetSource(idSource)
  return resp
}

export async function getListOfContents(idSource, params) {
  const result = await beContentProviderGetListOfContents(idSource, params)
  return result
}
